import React from 'react';
import { Modal } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';
import { useFunctionShare } from './useFunctionShare';

const DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const dayOf = (d) => { const t = new Date(`${String(d || '').slice(0, 10)}T00:00:00`); return Number.isNaN(t.getTime()) ? '' : DAY[t.getDay()]; };

// Phone "share these functions": the functions as full-width tap rows, the
// message boxes, the preview underneath; Copy / Share another way as two big
// buttons, Send on WhatsApp at the bottom.
export default function ShareFunctionsMobile(props) {
  const vm = useFunctionShare(props);
  const {
    invitable, picked, toggle, allOn, toggleAll, chosen,
    from, setFrom, message, setMessage, withMap, setWithMap,
    preview, copy, whatsapp, share, canShare, close,
  } = vm;

  return (
    <Modal
      fullScreen className="ev-m" title="Share functions" onClose={close}
      footer={<>
        <button className="btn light" style={{ flex: '0 0 auto' }} onClick={close}>Close</button>
        <button className="btn primary" data-save="primary"
          disabled={!chosen.length} onClick={whatsapp}>
          Send on WhatsApp{chosen.length ? ` (${chosen.length})` : ''}
        </button>
      </>}
    >
      <div className="ev-section">
        <span className="step-label">Which functions</span>
        <span className="ev-tools">
          <button type="button" className="ev-link" onClick={toggleAll}>{allOn ? 'None' : 'All'}</button>
        </span>
      </div>
      <div className="ev-m-rows">
        {invitable.length === 0 && <div className="muted">Every function of this event is over.</div>}
        {invitable.map(f => {
          const on = picked.includes(String(f.FunctionId));
          return (
            <button key={f.FunctionId} type="button" className={'ev-m-row' + (on ? ' on' : '')}
              aria-pressed={on} onClick={() => toggle(f.FunctionId)}>
              <span className="ev-m-check">{on ? '✓' : ''}</span>
              <span className="ev-share-name">{f.FunctionName}</span>
              <span className="ev-share-when">
                {dayOf(f.FunctionDate)} {fmtDate(f.FunctionDate).slice(0, 5)}{f.StartTime ? ` · ${fmtTime(f.StartTime)}` : ''}
              </span>
            </button>
          );
        })}
      </div>

      <label className="field">Message on top
        <textarea rows={2} value={message} onChange={e => setMessage(e.target.value)} />
      </label>
      <label className="field">From
        <input value={from} onChange={e => setFrom(e.target.value)} placeholder="Ailani Family" />
      </label>
      <label className="share-fn-map" style={{ padding: '6px 0 10px', fontSize: 14 }}>
        <input type="checkbox" checked={withMap} onChange={e => setWithMap(e.target.checked)} style={{ width: 20, height: 20 }} />
        Add a map link for each venue
      </label>

      <div className="step-label">What they receive</div>
      <div className="share-fn-preview">
        {preview.map(line => (
          <div key={line.key} className={line.signature ? 'share-fn-sign' : undefined}>
            {line.parts.map((p, i) => (p.bold ? <strong key={i}>{p.text}</strong> : <span key={i}>{p.text}</span>))}
            {line.parts.length === 0 ? ' ' : null}
          </div>
        ))}
      </div>

      <div className="ev-m-actions">
        <button className="btn light" onClick={copy}>⧉ Copy message</button>
        {canShare && <button className="btn light" onClick={share}>↗ Share another way</button>}
      </div>
    </Modal>
  );
}
